import React, { type ReactNode } from 'react';

import { Stack, Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import type { Size as SpinnerSize } from '@atlaskit/spinner/types';

type LoadingContentSize = Extract<SpinnerSize, 'small' | 'large'>;

export const LoadingContent = ({
	loadingText,
	size,
}: {
	loadingText: ReactNode;
	size: LoadingContentSize;
}): React.JSX.Element => {
	const stackSpace = size === 'large' ? 'space.400' : 'space.200';

	return (
		<Stack space={stackSpace} alignInline="center">
			{/* Doesn't need a label because the text below it is present. No label === presentational */}
			<Spinner size={size} label="" />
			<Text color="color.text.subtle">{loadingText}</Text>
		</Stack>
	);
};
